import EventsTracking from '../../../../shared/eventsTracking';

export default {
  mounted() {
    const { taggingId } = this;

    this.clickTrackerOptions = { capture: false, once: false };
    this.playbackTrackerOptions = { capture: true, once: true };
    this.tracking = new EventsTracking(taggingId, this);
  },
};
